import { render, staticRenderFns } from "./FeedInfo.vue?vue&type=template&id=21d5baa0&"
import script from "./FeedInfo.vue?vue&type=script&lang=js&"
export * from "./FeedInfo.vue?vue&type=script&lang=js&"
import style0 from "./FeedInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports